import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { api } from "@/lib/api";
import { Settings as SettingsIcon, Store, Bell, Sparkles } from "lucide-react";
import ManagersPanel from "@/components/ManagersPanel";

export default function StoreSettings() {
  const { user } = useAuth();
  const [store, setStore] = useState(null);

  useEffect(() => {
    api.get("/store/me").then(r => setStore(r.data.store)).catch(() => {});
  }, []);

  return (
    <div data-testid="store-settings-page" className="space-y-6 max-w-3xl">
      <div>
        <div className="text-xs font-mono-tech uppercase tracking-[0.2em] text-cyan-400 mb-2">/ Settings</div>
        <h1 className="font-display text-3xl font-bold tracking-tight">Store Settings</h1>
      </div>

      <section className="border border-slate-200 dark:border-slate-800 rounded-lg p-6 bg-slate-100/40 dark:bg-slate-900/40">
        <div className="flex items-center gap-3 mb-4">
          <Store className="w-5 h-5 text-cyan-400" />
          <h2 className="font-display text-lg font-semibold">Store Profile</h2>
        </div>
        <div className="space-y-3 text-sm">
          <Row k="Store Name" v={store?.store_name} />
          <Row k="Owner" v={store?.owner_name} />
          <Row k="Email" v={user?.email} />
          <Row k="Phone" v={store?.phone} />
          <Row k="Business Address" v={store?.business_address} />
          <Row k="Status" v={<span className="text-green-400 font-mono-tech">{store?.status}</span>} last />
        </div>
      </section>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[
          { icon: Bell, title: "Notifications", text: "Get alerts when riders pick up and customers receive your packages." },
          { icon: SettingsIcon, title: "Team Members", text: "Invite teammates to manage products and packages with you." },
          { icon: Store, title: "Brand Page", text: "Public tracking page customers can scan to see live status." },
        ].map(c => (
          <div key={c.title} className="border border-slate-200 dark:border-slate-800 rounded-lg p-5 bg-slate-100/40 dark:bg-slate-900/40">
            <c.icon className="w-5 h-5 text-cyan-400 mb-3" />
            <div className="font-display font-semibold mb-1">{c.title}</div>
            <div className="text-xs text-slate-600 dark:text-slate-400 leading-relaxed">{c.text}</div>
            <div className="mt-3 inline-flex items-center gap-1 text-[10px] font-mono-tech uppercase tracking-wider text-yellow-400 border border-yellow-500/30 bg-yellow-500/5 rounded-full px-2 py-0.5">
              <Sparkles className="w-3 h-3" /> Coming Soon
            </div>
          </div>
        ))}
      </div>

      <ManagersPanel
        role="Store Manager"
        apiBase="/store/managers"
        testIdRoot="store-manager"
      />
    </div>
  );
}

function Row({ k, v, last }) {
  return (
    <div className={`flex justify-between gap-4 ${last ? "" : "border-b border-slate-200/60 dark:border-slate-800/60 pb-3"}`}>
      <span className="text-slate-500">{k}</span>
      <span className="text-slate-900 dark:text-white text-right break-all">{v || "—"}</span>
    </div>
  );
}
